<template>
<!-- 用户操作日志 -->
    <div class="main_container">
        <!-- 查询部分 -->
       <div class="condition_box clearfix userlog_main">
         <el-form :inline="true" :model="filters">
           <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form-item>
                    <span class="inp_title">申请人电话:</span>
                </el-form-item>
                <el-form-item class="form_item">
                    <el-input  class="inp_item" placeholder="电话" v-model="paramsdata.userName"></el-input>
                </el-form-item>
                <el-form-item>
                    <span  class="inp_title">类型:</span>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="paramsdata.type" placeholder="请选择">
                        <el-option
                        v-for="item in options2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form-item>
                    <span  class="inp_title">IP地址:</span>
                </el-form-item>
                <el-form-item>
                    <el-input  class="inp_item" placeholder="IP地址" v-model="paramsdata.iPAddress"></el-input>
                </el-form-item>
                <el-form-item>
                    <span  class="inp_title">操作日期:</span>
                </el-form-item>
                <el-form-item class="form_item">
                    <el-date-picker type="date" placeholder="选择日期" v-model="paramsdata.beginTime" value-format='yyyy-MM-dd'  style=""></el-date-picker>至
                    <el-date-picker type="date" placeholder="选择日期" v-model="paramsdata.endTime" value-format='yyyy-MM-dd'   style=""></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="chaxun_btn" @click="searchFn">查询</el-button>
                    <!-- <el-button type="primary" class="shuaxin_btn">刷新</el-button> -->
                </el-form-item>
            </el-col>
           </el-form>
       </div>
       <!-- 内容部分 -->
       <div class="table_box">
            <my-table :items="tableData" :headers="tableHeader" :oprateOption="oprateOption"  :totalNum="TotalNum" :pageSize="paramsdata.pageSize" @getTableData="getTableData" :listLoading="listLoading" :oprateItems="oprateBtns" @viewFn="viewFn" @editFn="editFn">
                <template slot-scope='{props}' slot="TypeText">
                    <span >
                    {{props.row.TypeText}}
                    </span>
                </template>
            </my-table>
        </div>

    </div>
</template>
<script>
//userLogGetBysearchParam
import MyTable from '@/components/Table'
export default {
    components: {
        MyTable
    },
    data(){
        return{
            finishTime:"",
            statTime:"",
            input2:"",
            input21:"",
            filters:{},
            tableData3: [],
            border:true,
            options2: [{
                value: '1',
                label: '登录'
                }, {
                value: '2',
                label: '注册',
                //disabled: true
                }, {
                value: '3',
                label: '修改密码'
                }, {
                value: '4',
                label: '提交'
                },
                // {
                // value: '5',
                // label: '审核'
                // },
                // {
                // value: '6',
                // label: '执行撤除'
                // },
                {
                value: '-1',
                label: '全部'
                }
                ],
                value2: '',
                currentPage1: 5,
                border:true,
                currentPage1: 5,
                listLoading: true,
                tableHeader: [
                    {prop: 'UserName', label: '申请人电话'},
                    {prop: 'TypeText', label: '类型',show:'template'},
                    {prop: 'BeginTime', label: '操作日期'},
                    {prop: 'IPAddress', label: 'IP地址'},
                ],
                oprateBtns: [
                    {text: '启用', method: 'viewFn',class: 'view_btn', key: 'qy'},
                    {text: '禁用', method: 'editFn', key: 'jy'},
                ],
                tableData: [
                ],
                oprateOption:{
                    hasOprate:false,
                    oprateName:"操作",
                    width:""
                },
                TotalNum: 1,
                statusMap: {
                    1: '已启用',
                    0: '已禁用'
                },
                paramsdata : {
                    userName:"",
                    type:'-1',
                    iPAddress:"",
                    beginTime:"",
                    endTime:"",
                    // phoneNum: "",
                    pageIndex:1,//第几页
                    pageSize:20//每页多少条
                },
            }
    },
    methods:{
        handleClick(row){
            // this.$router.push('/applyIndex/viewCancel');
            console.log("row---",row.id);
            this.$router.push({
                path:"/viewInfo",
                name:'撤除申请详情',
                params:{
                    id:row.id
                }
            });
        },
        viewFn (d){
        console.log('view------',d);
        },
        editFn (d){
        console.log('edit------',d);
        },
        getTableData(p){
        var _this = this;
        _this.listLoading = true;
        if (!p){
            p = 1;
        }
        console.log('getdata', p)
        if (!!p) {
            this.paramsdata.pageIndex=p;
        }
        _this.$api.userLogGetBysearchParam(this.paramsdata).then(res=>{
            console.log("res====",res.data.SearchList);
            if(res.data&&res.data.result){
            var tableData = res.data.info.SearchList || [];
            _this.TotalNum = res.data.info.TotalNum;
            tableData.forEach((item) => {
                if(item.Type==1){
                    item.TypeText="登录"
                }else if(item.Type==2){
                    item.TypeText="注册"
                }else if(item.Type==3){
                    item.TypeText="修改密码"
                }else if(item.Type==4){
                    item.TypeText="提交"
                }else if(item.Type==5){
                    item.TypeText="审核"
                }else if(item.Type==6){
                    item.TypeText="执行撤除"
                }

            })
            _this.tableData=tableData;
            _this.listLoading = false;
            }else{
            this.$message({
                message: res.data.message,
                type: 'error',
                duration: 5 * 1000
            })
            }

            })
        },
        searchFn(){
            this.getTableData();
        }
    },
    created(){
        this.getTableData();
    }

}
</script>
<style >

 .el-input__inner{
    height: 34px;
}

.userlog_main .el-select>.el-input{
    width:293px;
}
.userlog_main .el-input{
    width:293px;
}
.el-date-editor.el-input{
    width:140px;
}
</style>

<style <style lang="scss" scoped>

    .condition_box{
        border:1px solid #DCDFE6;
        padding-top: 10px;
        // border-bottom:none;
    }
     .toolbar{
        background: transparent;
        padding: 0;
        margin: 0px;
     }
     .inp_title{
        display:inline-block;
        width:112px;
        text-align: right;
     }
    .chaxun_btn,.shuaxin_btn{
        height:34px;
        margin-left:600px;
        line-height:10px;
    }
    .shuaxin_btn{
        margin-left:10px;
    }

</style>




// WEBPACK FOOTER //
// userLog.vue?773533a7